import { ComponentProps } from 'react'
import { alpha3ToNumeric } from 'i18n-iso-countries'
import { ComposableMap, Geographies, Geography } from 'react-simple-maps'
import countries from 'world-atlas/countries-110m.json'

import { valueAmount } from '../../types/insights.types'
import { valueFormatterFor } from '../../utils/formatValue'
import {
  bucketColour,
  MAP_NO_DATA_COLOUR,
  rowsBuckets,
} from '../../utils/mapBuckets'
import { ChartBodyProps } from './chartBodies'

const ANTARCTICA_ID = '010'

// react-simple-maps reads a TopoJSON topology at runtime but types `geography` as GeoJSON only.
const WORLD = countries as unknown as ComponentProps<
  typeof Geographies
>['geography']

export function MapChartBody({ data, locale }: Readonly<ChartBodyProps>) {
  if (data.type !== 'rows') return null

  const format = valueFormatterFor(data.rows[0]?.value, locale)
  const buckets = rowsBuckets(data)
  const rowsById = new Map(
    data.rows.map((row) => [alpha3ToNumeric(row.key), row])
  )

  return (
    <ComposableMap
      width={800}
      height={360}
      projectionConfig={{ scale: 150, center: [0, 8] }}
      style={{ width: '100%', height: 'auto' }}
    >
      <Geographies
        geography={WORLD}
        parseGeographies={(features) =>
          features.filter((feature) => feature.id !== ANTARCTICA_ID)
        }
      >
        {({ geographies }) =>
          geographies.map((geography) => {
            const row = rowsById.get(String(geography.id))

            return (
              <Geography
                key={geography.rsmKey}
                geography={geography}
                fill={
                  row
                    ? bucketColour(buckets, valueAmount(row.value))
                    : MAP_NO_DATA_COLOUR
                }
                stroke="white"
                strokeWidth={0.5}
                tabIndex={-1}
              >
                <title>
                  {row
                    ? `${row.label}: ${format(valueAmount(row.value))}`
                    : geography.properties?.name}
                </title>
              </Geography>
            )
          })
        }
      </Geographies>
    </ComposableMap>
  )
}
